// A workflow as the marketplace lists it.
import { ArrowUpRight, SealCheck, Star } from "@phosphor-icons/react";
import { Link } from "react-router";

import type { WorkflowSummary } from "../../api/types";
import { WorkflowIcon } from "../../workflows/icons";

export function WorkflowCard({ workflow: w }: { workflow: WorkflowSummary }) {
  return (
    <Link to={`/workflows/${w.slug}`} className="card group flex flex-col p-6 transition-[transform,border-color] hover:-translate-y-1 hover:border-ink">
      <div className="flex items-start justify-between gap-3">
        <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-ink text-paper">
          <WorkflowIcon icon={w.icon} weight="duotone" className="h-6 w-6" aria-hidden />
        </span>
        <div className="flex flex-wrap justify-end gap-1.5">
          {w.featured ? (
            <span className="chip border-signal/40 text-signal">
              <Star weight="fill" className="h-3 w-3" aria-hidden /> Featured
            </span>
          ) : null}
          <span className="chip">{w.category}</span>
        </div>
      </div>
      <h3 className="mt-6 font-display text-2xl font-bold leading-tight tracking-tight">{w.name}</h3>
      <p className="mt-2 flex-1 text-[15px] leading-relaxed text-ink2">{w.summary}</p>
      <dl className="mt-6 grid grid-cols-3 gap-2 border-t border-line pt-4 text-center">
        {[
          ["steps", w.step_count],
          ["approvals", w.approval_count],
          ["versions", w.version_count],
        ].map(([label, value]) => (
          <div key={label}>
            <dd className="font-display text-2xl font-bold">{value}</dd>
            <dt className="font-mono text-[10.5px] uppercase tracking-wider text-ink3">{label}</dt>
          </div>
        ))}
      </dl>
      <div className="mt-4 flex items-center justify-between text-[13.5px] text-ink2">
        <span className="inline-flex items-center gap-1">
          <SealCheck weight="fill" className="h-4 w-4 text-teal" aria-hidden /> {w.publisher} · v{w.latest_version}
        </span>
        <ArrowUpRight weight="bold" className="h-4 w-4 transition-colors group-hover:text-signal" aria-hidden />
      </div>
    </Link>
  );
}
